import MonixModal from '@/global/components/monix-modal';
import './index.less';
import { useEffect, useState, useRef } from 'react';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { GlobalSensor } from '@/global/interface/lib-device/global-sensor';
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import { Sensor } from '@/global/interface/device/sensor';
import { getGlobalSensors } from '@/api/lib/lib-sensor';
import { getSensors } from '@/api/device/sensor';
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter';
import TnMessage from '@/global/components/message';


interface IProps {
    visible: boolean
    setVisible: (value: boolean) => void
    onFinish: (value: Sensor) => void
    selectParam: MonitorParameter
    loading: boolean
}

export default function SelectSensorRelationModal(props: IProps) {

    const { projectId } = useParams();
    const [sensors, setSensors] = useState<Sensor[]>([]); // 可选的传感器
    const [selected, setSelected] = useState<Sensor>(null); // 选中的传感器
    const [loading, setLoading] = useState<boolean>(false); // loading

    // 初始化
    useEffect(() => {
        if (!props.selectParam) return;
        if (props.visible) {
            generateData();
        } else {
            setSelected(null);
        }
    }, [props.visible, props.selectParam])


    // 获取可选择数据
    const generateData = () => {
        setLoading(true);
        getSensors(+projectId, {
            type: props.selectParam?.sensorType,
            globalParameterId: props.selectParam?.globalMonitorParameterId
        }).then(res => {
            let data: Sensor[] = res.data || [];
            data = data?.filter(item => item?.globalSensorId === props.selectParam?.globalSensorId && !item?.start) || [];
            setSensors(data);
        }).catch(err => {
            TnMessage.error("获取数据失败");
        }).finally(() => {
            setLoading(false);
        })
    }


    // 按下确认按钮
    const onSaveClick = () => {
        if (!selected) {
            props.setVisible(false);
            return;
        }
        if (props?.onFinish) {
            props.onFinish(selected);
        }
    }

    return (
        <MonixModal
            title={"选择传感器"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            onSaveClick={onSaveClick}
            wrapClassName="link-global-device-modal"
            saveDisable={props.loading}
        >
            <Spin wrapperClassName="link-global-device-body" spinning={loading}>
                <div className="link-body">
                    {sensors?.length !== 0 && sensors?.map((item, key) => (
                        <div className="link-item" key={key}>
                            <div className="item-icon" onClick={() => setSelected(item)}>
                                {selected?.id !== item.id && <CheckSvg />}
                                {selected?.id === item.id && <CheckedSvg />}
                            </div>
                            <div className="item-text">{`编码：${item?.code || ''}`}</div>
                        </div>
                    ))}
                    {sensors?.length === 0 && <div className="link-item">
                        <div className="item-text">{`暂无数据`}</div>
                    </div>
                    }
                </div>
            </Spin>
        </MonixModal>
    )
}